module.exports = __webpack_public_path__ + "img/service.33eccf25.png";